/* eslint-disable max-len */
import EDC from '../../../shared/globals';
import Answer from '../answer';
import Number from '../animations/number';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';

/**
 *
 */
EDC.Games.NumberNames.Scenes.Main = function () {
  BaseMinigamesMain.apply(this, [EDC.Games.NumberNames, 10]);

  this.gameConfig = store.getters['games/getGameById']().sets[0].config;
  this.difficulty = 1;
  this.iteration = 0;

  this.bubbleNumberBg = null;
  this.bubbleNumber = null;
  this.answers = [];
  this.answersDisappearedCount = 0;
  const slideDistance = 1100;

  this.posMap = [
    { x: 630, y: 640, slideDistance: slideDistance * -1 },
    { x: 1300, y: 640, slideDistance },
    { x: 410, y: 830, slideDistance: slideDistance * -1 },
    { x: 1540, y: 830, slideDistance },
  ];
};
/**
 *
 */
EDC.Games.NumberNames.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.NumberNames.Scenes.Main.prototype.constructor = EDC.Games.NumberNames.Scenes.Main;
/**
 *
 */
EDC.Games.NumberNames.Scenes.Main.prototype.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.startNewIteration();

  this.createBasicUI();
};

EDC.Games.NumberNames.Scenes.Main.prototype.createTemplateUI = function () {
  this.add.sprite(this.game.config.width / 2, 1020, 'label-title');

  this.bubbleNumberBg = this.add.sprite(this.game.config.width / 2, 0, 'number-bg');
  this.bubbleNumberBg.y += this.bubbleNumberBg.height / 2 + 50;
};
/**
 *
 */
EDC.Games.NumberNames.Scenes.Main.prototype.answerDisappeared = function () {
  this.answersDisappearedCount = this.answersDisappearedCount + 1;
  if (this.answersDisappearedCount >= this.posMap.length) {
    this.startNewIteration();
  }
  this.add
    .text(this.game.config.width / 2, 500, 'How do you write the number?', {
      fontFamily: 'Arial',
      fontSize: '60px',
      fontStyle: 'bold',
      color: '#ffffff',
      stroke: '#000000',
      strokeThickness: 6,
    })
    .setOrigin(0.5);
};

EDC.Games.NumberNames.Scenes.Main.prototype.correctAnswer = function () {
  this.iteration = this.iteration + 1;
  this.playCorrect();
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    for (let i = 0; i < this.answers.length; i++) {
      this.answers[i].removeInteractive();
    }
    this.cursorManager.resetCursor();
    setTimeout(() => {
      this.showSummary();
    }, 1000);
  } else {
    this.disappear();
  }
};

EDC.Games.NumberNames.Scenes.Main.prototype.disappear = function () {
  this.answersDisappearedCount = 0;
  if (this.bubbleNumber) {
    this.bubbleNumber.disappear();
  }
  for (let i = 0; i < this.answers.length; i++) {
    this.answers[i].disappear();
  }
};

EDC.Games.NumberNames.Scenes.Main.prototype.startNewIteration = function () {
  const data = this.gameConfig.sets[this.difficulty].iterations[this.iteration].choices;
  const targetNumber = this.gameConfig.sets[this.difficulty].iterations[this.iteration].correctAnswer;
  if (this.bubbleNumber) {
    this.bubbleNumber.destroy();
    delete this.bubbleNumber;
  }
  this.bubbleNumber = Number(this, targetNumber);
  this.bubbleNumber.create().place(this.bubbleNumberBg.x, this.bubbleNumberBg.y);

  const sourceWidth = this.bubbleNumber.getWidth();
  const targetWidth = (this.bubbleNumberBg.displayWidth * 85) / 100;
  let neededScaleX = 1.0;
  if (sourceWidth >= targetWidth) {
    neededScaleX = sourceWidth / targetWidth;
  }

  this.tweens.add({
    targets: this.bubbleNumberBg,
    scaleX: neededScaleX,
    duration: 250,
    ease: 'Linear',
  });

  this.bubbleNumber.appear();

  this.addAnswers(targetNumber, data);
};

EDC.Games.NumberNames.Scenes.Main.prototype.addAnswers = function (target, data) {
  const tmpAnswers = data.map((v) => {
    return v;
  });
  for (let i = 0; i < data.length; i++) {
    const rndIdx = Math.floor(Math.random() * tmpAnswers.length);
    const answerValue = tmpAnswers[rndIdx];
    tmpAnswers.splice(rndIdx, 1);
    if (this.answers[i]) {
      this.answers[i].changeValues(target, answerValue).appear();
    } else {
      const answer = new Answer(this, target, answerValue);
      answer.create();
      answer.place(this.posMap[i].x, this.posMap[i].y, this.posMap[i].slideDistance).appear();
      this.answers.push(answer);
    }
  }
};

EDC.Games.NumberNames.Scenes.Main.prototype.deactivateAnswers = function (exceptAnswer) {
  for (let i = 0; i < this.answers.length; i++) {
    if (this.answers[i] !== exceptAnswer) {
      this.answers[i].isInactive = true;
    }
  }
};

export default EDC.Games.NumberNames.Scenes.Main;
